// -------------------- LAB ACTION TYPES --------------------
// export const GET_CLEARED_LABS = "GET_CLEARED_LABS";
// export const GET_CLEARED_LABS_SUCCESS = "GET_CLEARED_LABS_SUCCESS";
// export const GET_CLEARED_LABS_FAIL = "GET_CLEARED_LABS_FAIL";

// export const GET_APPROVED_LABS = "GET_APPROVED_LABS";
// export const GET_APPROVED_LABS_SUCCESS = "GET_APPROVED_LABS_SUCCESS";
// export const GET_APPROVED_LABS_FAIL = "GET_APPROVED_LABS_FAIL";

// export const GET_UNAPPROVED_LABS = "GET_UNAPPROVED_LABS";
// export const GET_UNAPPROVED_LABS_SUCCESS = "GET_UNAPPROVED_LABS_SUCCESS";
// export const GET_UNAPPROVED_LABS_FAIL = "GET_UNAPPROVED_LABS_FAIL";

// export const APPROVE_UNAPPROVE_LAB = "APPROVE_UNAPPROVE_LAB";
// export const APPROVE_UNAPPROVE_LAB_SUCCESS = "APPROVE_UNAPPROVE_LAB_SUCCESS";
// export const APPROVE_UNAPPROVE_LAB_FAIL = "APPROVE_UNAPPROVE_LAB_FAIL";

// -------------------- DONATION APPOINTMENTS --------------------
export const GET_ALL_DONATION_APPOINTMENTS = "GET_ALL_DONATION_APPOINTMENTS";
export const GET_ALL_DONATION_APPOINTMENTS_SUCCESS =
  "GET_ALL_DONATION_APPOINTMENTS_SUCCESS";
export const GET_ALL_DONATION_APPOINTMENTS_FAIL = "GET_ALL_DONATION_APPOINTMENTS_FAIL";

// -------------------- Lab List ACTION TYPES --------------------
export const GET_ALL_LABS_LIST = "GET_ALL_LABS_LIST";
export const GET_ALL_LABS_LIST_SUCCESS =
  "GET_ALL_LABS_LIST_SUCCESS";
export const GET_ALL_LABS_LIST_FAIL = "GET_ALL_LABS_LIST_FAIL";

// -------------------- B2B ACTION TYPES --------------------
export const GET_CLEARED_IN_PAYMENTS = "GET_CLEARED_IN_PAYMENTS";
export const GET_CLEARED_IN_PAYMENTS_SUCCESS =
  "GET_CLEARED_IN_PAYMENTS_SUCCESS";
export const GET_CLEARED_IN_PAYMENTS_FAIL = "GET_CLEARED_IN_PAYMENTS_FAIL";

export const GET_APPROVED_IN_PAYMENTS = "GET_APPROVED_IN_PAYMENTS";
export const GET_APPROVED_IN_PAYMENTS_SUCCESS =
  "GET_APPROVED_IN_PAYMENTS_SUCCESS";
export const GET_APPROVED_IN_PAYMENTS_FAIL = "GET_APPROVED_IN_PAYMENTS_FAIL";

export const GET_UNAPPROVED_IN_PAYMENTS = "GET_UNAPPROVED_IN_PAYMENTS";
export const GET_UNAPPROVED_IN_PAYMENTS_SUCCESS =
  "GET_UNAPPROVED_IN_PAYMENTS_SUCCESS";
export const GET_UNAPPROVED_IN_PAYMENTS_FAIL =
  "GET_UNAPPROVED_IN_PAYMENTS_FAIL";

export const UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT = "UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT";
export const UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT_SUCCESS =
  "UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT_SUCCESS";
export const UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT_FAIL =
  "UPDATE_APPROVE_UNAPPROVE_IN_PAYMENT_FAIL";

// -------------------- DONOR ACTION TYPES --------------------
// export const GET_CLEARED_DONORS = "GET_CLEARED_DONORS";
// export const GET_CLEARED_DONORS_SUCCESS = "GET_CLEARED_DONORS_SUCCESS";
// export const GET_CLEARED_DONORS_FAIL = "GET_CLEARED_DONORS_FAIL";

// export const GET_APPROVED_DONORS = "GET_APPROVED_DONORS";
// export const GET_APPROVED_DONORS_SUCCESS = "GET_APPROVED_DONORS_SUCCESS";
// export const GET_APPROVED_DONORS_FAIL = "GET_APPROVED_DONORS_FAIL";

// export const GET_UNAPPROVED_DONORS = "GET_UNAPPROVED_DONORS";
// export const GET_UNAPPROVED_DONORS_SUCCESS = "GET_UNAPPROVED_DONORS_SUCCESS";
// export const GET_UNAPPROVED_DONORS_FAIL = "GET_UNAPPROVED_DONORS_FAIL";

// export const APPROVE_UNAPPROVE_DONOR = "APPROVE_UNAPPROVE_DONOR";
// export const APPROVE_UNAPPROVE_DONOR_SUCCESS =
//   "APPROVE_UNAPPROVE_DONOR_SUCCESS";
// export const APPROVE_UNAPPROVE_DONOR_FAIL = "APPROVE_UNAPPROVE_DONOR_FAIL";
